import { Label } from "@krea/customer-features/shared-components/fields/label";
import LabeledRadioButton from "@krea/customer-features/shared-components/loan-application-form/fields/labeled-radio-button";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

interface IAllowedCustomerApplicationFlowProps {
  value: boolean;
  handleChange: (data: { name: string; value: boolean }) => void;
}

const AllowedCustomerApplicationFlow = ({
  value,
  handleChange,
}: IAllowedCustomerApplicationFlowProps) => {
  const { t } = useTranslation();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const newValue = e.target.value === "true";

    handleChange({ name, value: newValue });
  };

  return (
    <div>
      <Label className="tw-mb-2">
        {t("applicationForm.isCustomerApplicationFlowAllowed.label")}
      </Label>
      <LabeledRadioButton
        name="allowed_customer_application_flow"
        title={t(
          "applicationForm.isCustomerApplicationFlowAllowed.allowedOption",
        )}
        value={true}
        onChange={onChange}
        checked={value}
      />
      <LabeledRadioButton
        name="allowed_customer_application_flow"
        title={t(
          "applicationForm.isCustomerApplicationFlowAllowed.disallowedOption",
        )}
        value={false}
        onChange={onChange}
        checked={!value}
      />
    </div>
  );
};

export default AllowedCustomerApplicationFlow;
